"use client";

import DATA from "./data.json";
import Image from "next/image";
import React from "react";
import styles from "./AboutUsCard.module.css";
import { useLocale } from "next-intl";

type Card = {
  ar: {
    name: string;
    image: string;
    description?: string;
  };
  en: {
    name: string;
    image: string;
    description?: string;
  };
};

const AboutUsCard = () => {
  const locale = useLocale() as "ar" | "en";
  const data = [...DATA].reverse();

  return (
    <div className={styles.cardContainer}>
      {data.map((card: Card, i) => {
        const { name, image, description } = card[locale];
        return (
          <div className={styles.card} key={i}>
            <Image
              src={image}
              alt={name}
              className={styles.image}
              width={232}
              height={163}
            />
            <h4 className={styles.title}>{name}</h4>
            {description && <p className={styles.description}>{description}</p>}
          </div>
        );
      })}
    </div>
  );
};

export default AboutUsCard;
